module.exports = __webpack_public_path__ + "static/media/bgSolarPanelEvening.07184b9a.jpg";